import { ActionIcon, Group, Modal, Text, Tooltip } from "@mantine/core";
import { useMemo, useState } from "react";
import { getProspectBio } from "../../../../../utils";
import { IconLinkedin } from "../../../../../../../../components/Icons/IconLinkedin";
import { IconBrandLinkedin } from "@tabler/icons-react";
import AnswerSenderLinkedin from "./AnswerSenderLinkedin";
import { useLanguage } from "../../../../../../../../stores/LanguageStore";
import AnswerSenderLinkedinMobile from "../../../mobile/AnswerSenderLinkedinMobile";

const LinkedinSenderModal = ({
  isIcon,
  current,
  onSent,
  isInvitation,
  isMobile,
}) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);

  const about = useMemo(() => {
    const aboutList = [
      { key: "%last_name%", value: "lastName" },
      { key: "%first_name%", value: "firstName" },
      { key: "%job_title%", value: "jobTitle" },
      { key: "%company%", value: "company" },
      { key: "%phone%", value: "phone" },
      { key: "%contact_image_url%", value: "contact_image_url" },
      { key: "%linkedin_url%", value: "linkedin_url" },
      { key: "%email%", value: "email" },
    ];
    let result = {};

    aboutList.forEach((item) => {
      result[item.value] = current?.properties?.find(
        (x) => x.identifier_placeholder === item.key
      )?.value;
    });

    return result;
  }, [current?.properties]);

  const handleOpen = () => {
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
  };

  return (
    <>
      {isIcon ? (
        <Tooltip label={lang.leads.start_linkedin_conversation}>
          <ActionIcon variant="light" size={"lg"} onClick={handleOpen}>
            <IconBrandLinkedin size={20} />
          </ActionIcon>
        </Tooltip>
      ) : (
        <Group onClick={handleOpen}>
          <IconLinkedin size={20} />
          {isInvitation ? (
            <Text>{lang.leads.send_linkedin_invitation}</Text>
          ) : (
            <Text>{lang.leads.send_linkedin_message}</Text>
          )}
        </Group>
      )}

      {isMobile && opened ? (
        <AnswerSenderLinkedinMobile
          prospect={current}
          about={getProspectBio(current)}
          setAnswering={setOpened}
          setProspectLoading={onSent}
          isInvitation={isInvitation}
          alreadyOpened
          handleClose={handleClose}
          title={
            <>
              {lang.leads.start_email_conversation} {lang.prm.status.with}:{" "}
              <br />
              <b>
                {about?.firstName || " - "} {about.lastName || " - "} ({" "}
                {about?.email} )
              </b>
            </>
          }
        />
      ) : (
        <Modal
          opened={opened}
          onClose={handleClose}
          title={
            isInvitation
              ? lang.leads.send_linkedin_invitation
              : lang.leads.send_linkedin_message
          }
          size={900}
        >
          <AnswerSenderLinkedin
            prospect={current}
            about={getProspectBio(current)}
            setAnswering={setOpened}
            setProspectLoading={onSent}
            isInvitation={isInvitation}
          />
        </Modal>
      )}
    </>
  );
};

export default LinkedinSenderModal;
